import Vue from "vue";
import VueRouter from "vue-router";
import Meta from "vue-meta";
import store from "@/store";
import {
  publicRoutes,
  privateRoutes,
  docsRoutes,
  eventsRoutes,
  financesRoutes,
  marketplaceRoutes,
  peopleRoutes,
  redefinePassRoutes,
  producersRoutes,
  reportsRoutes,
  salesRoutes,
  settingsRoutes,
  checkinRoutes,
  marketingRoutes,
  DigitalWalletRoutes,
  // ResumeEventoRoutes,
} from "@/router/routes";

Vue.use(VueRouter);
Vue.use(Meta);

function getCookie(cookieName) {
  let allCookies = document.cookie.split(";");
  for (let i = 0; i < allCookies.length; i++) {
    let cookie = allCookies[i].split("=");
    if (cookie[0].trim() === cookieName) {
      return cookie[1];
    }
  }
}

const routes = [
  ...publicRoutes,
  ...privateRoutes,
  ...docsRoutes,
  ...eventsRoutes,
  ...financesRoutes,
  ...marketplaceRoutes,
  ...peopleRoutes,
  ...redefinePassRoutes,
  ...producersRoutes,
  ...reportsRoutes,
  ...salesRoutes,
  ...settingsRoutes,
  ...checkinRoutes,
  ...marketingRoutes,
  ...DigitalWalletRoutes,
  // ...ResumeEventoRoutes,
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});

// async function isAuthenticated() {
//   return await getCookie("oe_jwt");
// }

router.beforeEach((to, from, next) => {
  store.commit("setRoute", to.name);

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (
      to.matched.some(
        record =>
          record.meta.requiresAdminProfile && store.getters.isEventProfile
      )
    ) {
      next("/home");
      return;
    }
    if (getCookie("oe_jwt")) {
      next();
      return;
    }
    next("/");
  }
  next();
});

export default router;
